import React from 'react';
import styled from 'styled-components';
import compose from 'lodash/fp/compose';
import { withRouter } from 'react-router';
import { withCookies } from '@catalogo/core-connect/cookies';
import { withConfig } from '@catalogo/core-connect/config';
import { withMetrics } from '@catalogo/core-metrics';
import ProductInfo from './components/product-info';
import Breadcrumb from './components/breadcrumb';
import ProductOffer from './components/product-offer';

export const ProductMainArea = props => (
  <>
    <Breadcrumb breadcrumb={props.breadcrumb} textLowerCase />
    <Container>
      <TopWrapper>
        <ProductInfo {...props} />
        <ProductOffer {...props} />
      </TopWrapper>
    </Container>
  </>
);

const Container = styled.div`
  background: #fff;
  border-radius: 24px 24px 0px 0px;
`;

const TopWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`;

export default compose(withRouter, withCookies, withConfig, withMetrics)(ProductMainArea);
